import React from 'react'

import { Modal } from 'react-bootstrap'

export default class formInput extends React.Component {

    render() {
        const { changeHandler, saveHandler, Model, cancelHandler, showModal, Errors, mode, konfirmHandler} = this.props

        return (
            <div class="mb-10">

                <Modal show={showModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{mode} Golongan Darah</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div class="mb-3">
                            <label for="code" class="form-label">Kode*</label>
                            <input type="code" class="form-control" id="code" value={Model.code} onChange={changeHandler("code")}></input>
                            <span className="error" style={{color:"red", fontStyle:"italic"}}>{Errors["code"]}</span>
                            <span className="error" style={{color:"red", fontStyle:"italic"}}>{Errors["code1"]}</span>
                        </div>

                        <div class="mb-3">
                            <label for="description" class="form-label">Description</label>
                            <input type="description" class="form-control" id="description" value={Model.description} onChange={changeHandler("description")}></input>
                            {/* <span className="error">{errors["description"]}</span> */}
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="cancel" class="btn btn-warning" onClick={cancelHandler}>Batal</button>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Simpan</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}